<template>
    <div>
        <div class="title">{{ data.title }}</div>
        <div class="desc">{{ data.description }}</div>
        <div class="title">创作分构成</div>
        <div class="structure-box">
            <div class="structure-item" v-for="(item, index) in data.structure" :key="index">
                <div class="structure-item-title"
                    ><span class="structure-item-index">{{ index + 1 }}</span
                    ><span>{{ item.name }}</span></div
                >
                <div class="structure-item-desc">
                    {{ item.intro }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default { name: 'points-intro', props: { data: { type: Object, required: true } } };
</script>

<style lang="less" scoped>
.title {
    font-weight: 500;
    font-size: 0.34rem;
    line-height: 0.46rem;
    color: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    margin-top: 0.6rem;
    &::before {
        display: inline-block;
        content: '';
        width: 0.08rem;
        height: 0.32rem;
        background: #f7365d;
        margin-right: 0.16rem;
    }
}
.desc {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 0.26rem;
    line-height: 0.4rem;
    text-align: justify;
    color: rgba(255, 255, 255, 0.5);
    margin-top: 0.4rem;
}
.structure-box {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: space-between;
    margin-top: 0.32rem;
}
.structure-item {
    width: 49%;
    padding: 0.24rem;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 0.16rem;
    margin-bottom: 0.16rem;
    height: 1.84rem;
    box-sizing: border-box;
}
.structure-item-title {
    display: flex;
    font-weight: 500;
    font-size: 0.26rem;
    color: #fff;
    align-items: center;
}
.structure-item-index {
    width: 0.32rem;
    height: 0.32rem;
    background: rgba(255, 255, 255, 0.08);
    color: #fff;
    font-size: 0.22rem;
    border-radius: 0.16rem;
    line-height: 0.32rem;
    text-align: center;
    margin-right: 0.12rem;
}
.structure-item-desc {
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.2rem;
    margin-top: 0.16rem;
    line-height: 0.3rem;
}
</style>
